import { render, staticRenderFns } from "./ModalRuleCheckViolations.vue?vue&type=template&id=6dfb505f&scoped=true&"
import script from "./ModalRuleCheckViolations.vue?vue&type=script&lang=ts&"
export * from "./ModalRuleCheckViolations.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRuleCheckViolations.vue?vue&type=style&index=0&id=6dfb505f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb505f",
  null
  
)

export default component.exports